import { AUTH_PRIVILEGES } from "../api";
import { ACTIVITIES, DASHBOARD, FETCH_AUTH_PRIVILEGE, FETCH_CURRENT_USER, LOADING, SET_USER_PROFILE} from "../Dispatchers";
import { isloading } from "./LoadingReducer";

const initialState = {
    currentUser: {},
    dashboardData: {},
    privileges:[],
    activities:[],
    token:"",
    isloading:false
}
export function UserReducer(state = initialState, action) {
    switch (action.type) {
        case DASHBOARD:
            return {
                ...state, dashboardData: action.payload
            }
        case ACTIVITIES:
            return {
                ...state, activities: action.payload
            }
        case FETCH_CURRENT_USER:
            return {
                ...state, currentUser: action.payload
            }
        case FETCH_AUTH_PRIVILEGE:
            return {
                ...state, privileges: action.payload
            }
        case SET_USER_PROFILE:
            return {
                ...state, currentUser: action.payload
            }
        case LOADING:
            return {
                ...state, isloading: action.payload
            }
        

        default:
            break;
    }
    return state;
}